import { useSelector } from 'react-redux';

import {
  selectAnonymousUserCharacter,
  selectAnonymousUserProfileId,
  selectIsLoadingAnonymousData,
} from '@lib/core/users/selectors/anonymousUser';
import { actionCarryAnonymousUserData } from '@lib/core/users/slices/anonymousUser';
import { actionGetUserCharacters } from '@lib/core/users/slices/characters';
import { TUserDataField, USER_DATA_FIELDS } from '@lib/core/users/types';
import { useTypedDispatch } from '@lib/tools/views/hooks/useTypedDispatch';

export const useAnonymousUser = () => {
  const dispatch = useTypedDispatch();

  const anonymousUserCharacter = useSelector(selectAnonymousUserCharacter);
  const anonymousUserProfileId = useSelector(selectAnonymousUserProfileId);
  const isLoadingAnonymousData = useSelector(selectIsLoadingAnonymousData);

  const dispatchActionMap: Record<TUserDataField, () => any> = {
    [USER_DATA_FIELDS.QUIZ]: actionGetUserCharacters,
  };

  // Copies selected user data fields from one profile to another
  const carryAnonymousUserData = async (fields: TUserDataField[]) => {
    // Send request to copy data from anonymous profile to current user
    await dispatch(actionCarryAnonymousUserData(fields));

    // Refresh only the parts of user data that were copied
    const promises = fields.map(field => dispatch(dispatchActionMap[field]()));
    await Promise.all(promises);
  };

  return { anonymousUserCharacter, anonymousUserProfileId, carryAnonymousUserData, isLoadingAnonymousData };
};
